export type Contact = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
};

export type ContactDetails = Contact & {
  phoneNumber?: string | null;
  externalId?: string | null;
};

export type SavedContact = {
  id: string;
  firstName: string;
  lastName: string;
};

export type ContactsStatus = 'loading' | 'failed' | 'loaded';

export type RecipientOrganization = {
  id: string;
  name: string;
  sellingOrganizationCode?: string | null;
};

export function contactLabel(contact: Contact): string {
  return [contact.firstName, contact.lastName].filter(Boolean).join(' ');
}
